// import React from "react";
// import Header from "../components/Header";
// function Home() {
//   return (
//     <div className="home">
//       <Header />
//       <h1>Welcome to Cable!</h1>
//       <p>Your one-stop solution for all your cable needs.</p>
//     </div>
//   );
// }

// export default Home;

import Header from "../components/Header";
import Footer from "../components/Footer";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
export default function Home() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [team, setTeam] = useState([]);

  useEffect(() => {
    fetch("/data.json")
      .then((response) => response.json())
      .then((data) => {
        setProducts(data.cables);
        setTeam(data.team);
      })
      .catch((error) => console.error("Error fetching products:", error));
  }, []);
  return (
    <div className="bg-black text-white">
      {/* HERO SECTION */}
      <section
        className="relative min-h-screen bg-cover bg-center"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('https://images.unsplash.com/photo-1517846693594-1567da72af75?q=80&w=1600&auto=format&fit=crop')",
        }}
      >
        <Header />

        <div className="flex flex-col justify-center items-start min-h-[80vh] px-6 md:px-16">
          <p className="text-yellow-400 tracking-[4px] uppercase text-sm md:text-base mb-4">
            Premium Motorcycle Cables
          </p>

          <h1 className="text-4xl sm:text-5xl md:text-7xl font-extrabold leading-tight mb-8">
            HIGH PERFORMANCE <br /> BIKE CONTROL CABLES
          </h1>

          <a
            href="#product"
            className="border border-white px-6 py-3 md:px-8 md:py-4 uppercase text-sm tracking-wide hover:bg-white hover:text-black transition"
          >
            Explore Products
          </a>
        </div>
      </section>
      <div class="text-white relative overflow-hidden">
        <div class="shape hidden md:block w-[250px] h-[300px] top-0 right-[350px]"></div>

        <div class="shape hidden md:block w-[420px] h-[450px] top-0 right-[-120px]"></div>

        <div class="shape hidden md:block w-[420px] h-[520px] bottom-[40px] left-[-120px]"></div>

        <div class="shape hidden md:block w-[220px] h-[520px] bottom-[40px] left-[420px]"></div>

        <div class="shape hidden md:block w-[380px] h-[580px] bottom-[60px] right-[-200px]"></div>

        {/* ABOUT SECTION */}
        <section className="relative   z-10 min-h-screen px-4 sm:px-6 md:px-20 py-12 flex flex-col justify-between">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div className="text-center lg:text-left">
              <p className="text-lime-400 uppercase tracking-[4px] text-xs sm:text-sm mb-3">
                Precision Cable Systems
              </p>

              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold uppercase leading-tight mb-6">
                The Power Behind Smooth Riding
              </h2>

              <p className="text-gray-300 text-base sm:text-lg leading-7 mb-5">
                Bike cables are the hidden system that control braking and gear
                shifting. From stainless steel inner wires to durable outer
                housing, every component ensures smooth, responsive, and safe
                riding performance.
              </p>

              <p className="text-gray-400 mb-6">
                High-quality cable systems reduce friction, improve shifting
                accuracy, and enhance braking control. Whether it's a road bike,
                mountain bike, or custom build, properly tuned cables make all
                the difference in performance and rider confidence.
              </p>
            </div>

            <div class="flex justify-center">
              <div class="w-full max-w-sm sm:max-w-md">
                <img
                  src="https://external-content.duckduckgo.com/iu/?u=https://www.slashgear.com/img/gallery/this-is-the-smoothest-riding-harley-davidson-according-to-users/heres-why-the-road-glide-is-the-smoothest-harley-davidson-1765807027.jpg&f=1"
                  class="w-full h-auto sm:h-[320px] object-cover rounded-lg"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div
            id="stats"
            class="grid grid-cols-2 sm:grid-cols-4 gap-6 md:gap-10 text-center py-12 md:py-20"
          ></div>

          <div class="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div class="flex justify-center order-2 lg:order-1">
              <img
                src="https://superstrengthcables.in/wp-content/uploads/2020/11/custom-bike-builder-motorcycle.png"
                alt=""
                class="w-full max-w-md sm:max-w-lg object-contain"
              />
            </div>
            <div class="max-w-xl text-center lg:text-left order-1 lg:order-2">
              <p class="text-[#c7ff1e] uppercase tracking-[4px] text-xs sm:text-sm mb-3">
                What We Do
              </p>

              <h2 class="text-3xl sm:text-4xl md:text-5xl font-bold uppercase leading-tight mb-6">
                Precision Bike Cable Systems
              </h2>

              <p class="text-gray-300 leading-7 mb-6 text-base sm:text-lg">
                We design and assemble high-performance cable systems for
                braking and gear shifting. From inner steel wires to
                low-friction outer housings, every setup is engineered for
                smooth response, durability, and control on every ride.
              </p>
              <ul class="space-y-4 mb-8 text-left">
                <li class="flex items-center gap-3">
                  <span class="text-[#c7ff1e] mt-1">▶</span>
                  <span>
                    High-tensile steel inner cables for precision shifting
                  </span>
                </li>

                <li class="flex items-center gap-3">
                  <span class="text-[#c7ff1e] mt-1">▶</span>
                  <span>
                    Low-friction outer housing for smoother braking response
                  </span>
                </li>

                <li class="flex items-center gap-3">
                  <span class="text-[#c7ff1e] mt-1">▶</span>
                  <span>
                    Weather-resistant coating for long-lasting performance
                  </span>
                </li>

                <li class="flex items-center gap-3">
                  <span class="text-[#c7ff1e] mt-1">▶</span>
                  <span>
                    Custom tuning for road, MTB, and performance bikes
                  </span>
                </li>
              </ul>
              <a
                href="/work"
                class="inline-block border border-[#c7ff1e] px-8 py-3 uppercase text-sm tracking-[3px] hover:bg-[#c7ff1e] hover:text-black transition"
              >
                Check Our Works
              </a>
            </div>
          </div>
        </section>
      </div>

      {/* WORKS SECTION */}
      <section id="product" className="py-20 px-6 md:px-10">
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold uppercase">
            Our Latest Builds
          </h2>
        </div>

        <div className="grid gap-8 md:grid-cols-2 xl:grid-cols-3">
          {products.map((product) => (
            <div
              key={product.id}
              className="group relative overflow-hidden rounded-2xl bg-zinc-900 shadow-lg hover:shadow-2xl transition-all duration-500"
            >
              {/* Image */}
              <img
                src={product.image}
                alt={product.alt || product.name}
                className="h-[450px] w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-80" />
              {/* Content */}
              <div className="absolute bottom-0 left-0 w-full p-6 transform transition-all duration-500 group-hover:-translate-y-2">
                <span className="inline-block rounded-full bg-lime-400 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-black">
                  {product.category}
                </span>

                <h3 className="mt-4 text-2xl font-bold text-white">
                  {product.title || product.name}
                </h3>

                <button
                  onClick={() => navigate(`/product/${product.id}`)}
                  className="mt-4 opacity-0 translate-y-4 rounded-lg bg-white px-5 py-2 font-medium text-black transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100"
                >
                  View Project →
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* TESTIMONIAL */}
      <section className="relative min-h-screen flex items-center bg-gradient-to-br from-black via-zinc-900 to-black overflow-hidden">
        {/* Background Blobs */}
        <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-lime-500/20 blur-[120px] rounded-full" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-purple-500/10 blur-[120px] rounded-full" />

        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Text Content */}
            <div className="space-y-8">
              <span className="text-lime-400 uppercase tracking-[6px] text-xs font-semibold">
                Client Testimonial
              </span>
              <h2 className="text-4xl md:text-5xl font-extrabold leading-tight uppercase">
                Precision that transforms every ride
              </h2>

              <p className="text-gray-400 text-lg leading-relaxed max-w-xl">
                “The cable system completely changed my control on the track—
                smooth braking, sharper response, and unmatched reliability even
                under pressure.”
              </p>

              <div className="pt-6 border-l-2 border-lime-400 pl-4">
                <h3 className="text-white text-xl font-semibold uppercase">
                  Ethan D. Saw
                </h3>
                <p className="text-gray-500 text-sm uppercase tracking-[3px] mt-1">
                  Professional Rider
                </p>
              </div>
            </div>

            {/* Image Section */}
            <div className="relative flex justify-center lg:justify-end">
              <div className="absolute w-72 h-96 border-2 border-lime-400/30 rotate-6" />
              <div className="absolute w-72 h-96 border border-white/10 -rotate-3" />

              <img
                src="/cable2.jpeg"
                alt="Ethan D. Saw"
                className="relative z-10 w-72 h-96 object-cover rounded-xl shadow-2xl"
              />

              <div className="absolute -top-10 -left-10 text-lime-400 text-[140px] font-bold opacity-20">
                ”
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TEAM SECTION */}
      <section className="bg-black py-24 px-6">
        <div className="text-center mb-16">
          <h2 className="text-white text-5xl md:text-7xl font-bold uppercase">
            Expert Team
          </h2>
          <p class="text-gray-300 text-lg mt-8 max-w-3xl mx-auto">
            Our dedicated team of engineers and technicians designs and tests
            high-performance cable systems to ensure smooth shifting, reliable
            braking, and long-lasting durability.
          </p>
        </div>

        <div
          id="teamMembers"
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {team.map((member) => (
            <div
              key={member.id}
              className="group relative bg-zinc-900 rounded-2xl overflow-hidden shadow-lg hover:shadow-lime-400/20 transition-all duration-500"
            >
              <div className="h-[360px] overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
              </div>

              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-90" />

              <div className="absolute bottom-0 w-full p-6 text-center">
                <h3 className="text-white text-xl font-bold uppercase tracking-wide">
                  {member.name}
                </h3>

                <p className="text-lime-400 text-sm uppercase tracking-[3px] mt-2">
                  {member.role}
                </p>

                <div className="w-0 group-hover:w-20 h-[2px] bg-lime-400 mx-auto mt-4 transition-all duration-500" />
              </div>

              <div className="absolute inset-0 rounded-2xl border border-white/10 group-hover:border-lime-400/40 transition" />
            </div>
          ))}
        </div>
      </section>

      <section
        className="relative min-h-screen flex items-center bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1558981806-ec527fa84c39?w=1920')",
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>

        <div className="relative  z-10 px-6 md:px-16">
          <h1 className="text-white text-4xl md:text-7xl font-bold uppercase">
            Precision Bike <br></br> Cable Systems
          </h1>
          <p class="mt-6 sm:mt-8 text-white/90 text-base sm:text-lg md:text-xl leading-relaxed max-w-2xl">
            High-performance brake and gear cable solutions engineered for
            smooth shifting, precise braking, and long-lasting durability. Built
            for riders, OEMs, and custom builders.
          </p>

          <a
            href="/contact"
            className="inline-block mt-10 border border-lime-400 text-lime-400 px-8 py-4 uppercase hover:bg-lime-400 hover:text-black transition"
          >
            LET'S TALK
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
